import { render, staticRenderFns } from "./ReservationScheduleTemplateList.vue?vue&type=template&id=2456cf61&scoped=true&lang=pug"
import script from "./ReservationScheduleTemplateList.vue?vue&type=script&lang=ts"
export * from "./ReservationScheduleTemplateList.vue?vue&type=script&lang=ts"
import style0 from "./ReservationScheduleTemplateList.vue?vue&type=style&index=0&id=2456cf61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2456cf61",
  null
  
)

export default component.exports